import useErrorHandler from '$app-web/hooks/use-error-handler';

import useSendForgotPasswordLinkToEmailEndpoint from './use-send-forgot-password-link-to-email.endpoint';

const useSendForgotPasswordLinkToEmail = () => {
    const { handleError } = useErrorHandler();

    const { mutate, isLoading, isError, isSuccess, ...rest } = useSendForgotPasswordLinkToEmailEndpoint({
        onError: (error) => handleError(error),
    });

    return {
        sendForgotPasswordLinkToEmail: mutate,
        isLoading,
        isError,
        isSuccess,
        ...rest,
    };
};

export default useSendForgotPasswordLinkToEmail;
